import { useEffect } from 'react';

export const usePageTitle = (title: string) => {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = title ? `${title} | CEC Track` : 'CEC Track - Continuing Education Credits Management';
    
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
};
